function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1.333,
  y: 5.333,
  width: 29.333,
  height: 21.333,
  rx: 2,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#card_svg__paint0_linear)",
  d: "M1.333 9.333h29.333v4H1.333z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 17.333,
  y: 20.667,
  width: 10.667,
  height: 3.333,
  rx: 0.5,
  fill: "url(#card_svg__paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "card_svg__paint0_linear",
  x1: 6.833,
  y1: 9.333,
  x2: 13.15,
  y2: 19.928,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "card_svg__paint1_linear",
  x1: 19.333,
  y1: 20.667,
  x2: 25.037,
  y2: 24.84,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgCard;